import image01 from "../images/min-quality/001.jpg";
import image02 from "../images/min-quality/002.jpg";
import image03 from "../images/min-quality/003.jpg";
import image04 from "../images/min-quality/004.jpg";
import image05 from "../images/min-quality/005.jpg";
import image06 from "../images/min-quality/006.jpg";
import image07 from "../images/min-quality/007.jpg";
import image08 from "../images/min-quality/008.jpg";
import image09 from "../images/min-quality/009.jpg";
import image10 from "../images/min-quality/010.jpg";

import image01H from "../images/high-quality/001.jpg";
import image02H from "../images/high-quality/002.jpg";
import image03H from "../images/high-quality/003.jpg";
import image04H from "../images/high-quality/004.jpg";
import image05H from "../images/high-quality/005.jpg";
import image06H from "../images/high-quality/006.jpg";
import image07H from "../images/high-quality/007.jpg";
import image08H from "../images/high-quality/008.jpg";
import image09H from "../images/high-quality/009.jpg";
import image10H from "../images/high-quality/010.jpg";

export const titles = [
  {
    id: "01",
    text: "Preface “To boldly go where no man has gone before...”",
    width: 24,
    yPercent: 20,
    x: 0,
    image: image01,
    imageH: image01H,
    y: 0,
  },
  {
    id: "02",
    text: "Astronauts in Training",
    width: 23.75,
    yPercent: 0,
    x: 33,
    image: image02,
    imageH: image02H,

    y: -10,
  },
  {
    id: "03",
    text: "Indoor Tests at the Manned Spacecraft Center",
    width: 39,
    yPercent: 45,
    x: 50,
    image: image03,
    imageH: image03H,

    y: 0,
  },
  {
    id: "04",
    text: "Saturn V and Lunar Landing Module",
    width: 33,
    yPercent: 20,
    x: 90,
    image: image04,
    imageH: image04H,

    y: 0,
  },
  {
    id: "05",
    text: "Houston: \nWe Have Lift-off",
    width: 32.8,
    yPercent: 65,
    x: 120,
    image: image05,
    imageH: image05H,

    y: -2,
  },
  {
    id: "06",
    text: "Journey Through Space",
    width: 31,
    yPercent: 0,
    x: 140,
    image: image06,
    imageH: image06H,

    y: 0,
  },
  {
    id: "07",
    text: "The Moon’s Surface",
    width: 16.5,
    yPercent: 50,
    x: 165,
    image: image07,
    imageH: image07H,

    y: 0,
  },
  {
    id: "08",
    text: "One Giant Leap for Mankind",
    width: 31.8,
    yPercent: 10,
    x: 185,
    image: image08,
    imageH: image08H,

    y: -5,
  },
  {
    id: "09",
    text: "Research and Experiments",
    width: 35,
    yPercent: 80,
    x: 205,
    image: image09,
    imageH: image09H,

    y: 0,
  },
  {
    id: "10",
    text: "Rendezvous in Space",
    width: 25.25,
    yPercent: 30,
    x: 230,
    image: image10,
    imageH: image10H,

    y: 0,
  },
];
